// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraWindowBase } from '../../screen/TerceraWindowBase';
export class TerceraDateDropDownBase extends TerceraWindowBase {
    getRangeStartAndEndClasses(date, dateFrom, dateTo) {
        if (isNullOrUndefined(dateFrom) || isNullOrUndefined(dateTo))
            return '';
        if (date >= dateFrom && date <= dateTo) {
            const classes = [];
            if (date.isSameDay(dateFrom))
                classes.push('range-start');
            if (date.isSameDay(dateTo))
                classes.push('range-end');
            return classes.join(' ');
        }
        return '';
    }
    getRangeClassesIfInRange(date, dateFrom, dateTo) {
        if (isNullOrUndefined(dateFrom) || isNullOrUndefined(dateTo))
            return null;
        return date >= dateFrom && date <= dateTo
            ? { classes: `datepicker--days-range ${this.getRangeStartAndEndClasses(date, dateFrom, dateTo)}`.trim() }
            : null;
    }
}
